<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
    <div id="faq-container">
        <div class="main-box-content">
            <div id="direction">
                <ul>
                    <li>خانه</li>
                    <li><img class="arrow" width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt="icon"></li>
                    <li>
                        سوالات متداول
                    </li>
                </ul>
            </div>
            <div class="title">
              سولات متداول
            </div>

            <div  v-for="item in infos" :key="item">
                <div class="title" style="font-size: 20px">
                    <ul>
                        <li>
                            <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                        </li>
                        <li>
                            {{item.title}}
                        </li>
                    </ul>
                </div>
                <Questions v-if="item" :items="item.options"/>
            </div>






            <div v-if="loadingMood">
                <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
            </div>
            <div id="footer-content"  v-if="infos">
                <div class="row">
                    <div class="small-div col-lg-4 col-md-4 col-sm-12"  v-if="$store.state.socialMediaLinks.telegram">
                        <a :href="$store.state.socialMediaLinks.telegram"   target="_blank">
                            <span>کانال تلگرام کانادا از ایران</span>
                            <img width="80" height="80" src="../assets/new/New/Logo.png" alt="">
                        </a>
                    </div>
                    <div class="small-div col-lg-4 col-md-4 col-sm-12" v-if="$store.state.socialMediaLinks.instagram">
                        <a :href="$store.state.socialMediaLinks.telegram"   target="_blank">
                            <span>اینستاگرام کانادا از ایران</span>
                            <img width="80" height="80" src="../assets/new/New/instagram.png" alt="">
                        </a>
                    </div>
                    <div class="small-div col-lg-4 col-md-4 col-sm-12">
                        <a v-on:click="$router.push('/user-signup')">
                            <span>فرم ارزشیابی رایگان</span>
                            <img width="80" height="80" src="../assets/new/New/Icon/clipboard.png" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>


        <div class="main-box-content" v-if="loginStatus && infos">
            <div class="title form-title" style="margin-top: 0">
                <ul>
                    <li>
                        <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                        افزودن نظر
                    </li>
                </ul>
            </div>
            <div class="form-container">
                <CommentForm :type="'faq'" :slug="'empty'" parentId=""/>
            </div>
        </div>
        <div class="notice-box" v-else-if="infos">
            <div class="main-box-content">
                <div class="row form-container login-txt" v-on:click="$router.push('/user-signin')" >
                        برای افزودن نظر جدید وارد شوید!
                </div>
            </div>
        </div>
        <div class="space"></div>
        <div class="main-box-content" v-if="comments">
            <div class="title form-title">
                <ul>
                    <li>
                        <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                        نظرات کاربران
                    </li>
                </ul>
            </div>
            <div v-for="comment in comments" :key="comment">
                <UserComment :layersCount="1" :comment="comment" :type="'faq'" :replyTo="null" :slug="'empty'"/>
            </div>
        </div>
        <div v-if="commentLoadingMood">
            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
    </div>
</template>

<script>
    import Questions from '../components/Questions'
    import UserComment from '../components/UserComment'
    import CommentForm from  '../components/CommentForm'
    import Alert from '../components/Alert'
    import axios from 'axios'
    export default {
        name: "Faq",
        data(){
            return {
                alertContent: null,
                loadingMood: false,
                infos:null,
                loginStatus: this.$store.state.loginStatus,
                comments:null,
                commentLoadingMood:false,
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getPageInfos/faqPage',
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                    this.loadingMood = false;
                    this.infos = response.data.results;

                } catch (error) {
                    console.log(error)
                }
            },
            async getComments() {
                try {
                    this.commentLoadingMood = true;
                    let response = await axios.get('api/getFaqPageComments',
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                    this.commentLoadingMood = false;
                    this.comments = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        components:{
            Questions,
            UserComment,
            Alert,
            CommentForm

        },
        mounted() {
            this.getPageInfos();
            this.getComments();
        },
    }
</script>

<style lang="scss" scoped>
    .login-txt{
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    }
    .form-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .main-box-content{
        max-width: 1120px;
        width: 100%;
        margin: auto;
        padding: 50px 0;
        .title{
            ul{
                padding: 0;
                display: flex;
            }
            width: 100%;
            text-align: right;
            font-size: 30px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1a1a1a;
            span{
                color: #cc171d;
            }
        }
    }
    .notice-box{
        background-color: rgba(232, 232, 232, 0.5);
        width: 100%;
        color: black;
    }
    .faq-container{
        overflow-x: hidden;
    }
    .arrow{
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        position: absolute;
    }
    #question-form{
        max-width: 1120px;
        width: 100%;
        background-color: black!important;
        margin: auto;
        padding: 50px 15px;


    }
    .space{
        height: 10px;
        width: 100%;
        background-color: #162336;
    }
    #footer-content{
        overflow: hidden;
        margin-top: 50px;
    }
    #faq-container{
        width: 100%;
        height: auto;
        background-color: white;
    }
    #main-content{
        padding-top: 50px;
        padding-bottom: 50px;
        text-align: right;
    }
    #direction>ul{
        padding: 0;
       text-align: right;
        list-style-type: none;
    }
    #direction>ul>li{
        position: relative;
        min-width: 30px;
        min-height: 10px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction>ul>li:nth-child(3){
        opacity: 0.3;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }
    .small-div{
        min-height: 140px;
        a{
            padding: 10px;
            margin-top: 15px;
            width: 100%;
            height: 140px;
            background-color: #162336;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            span{
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                margin: 20px;
            }
            image{

            }
        }
    }
    .main-box-content{
        max-width: 1120px;
        width: 100%;
        margin: auto;
        padding: 50px 15px;
        .title{
            width: 100%;
            text-align: right;
            font-size: 30px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1a1a1a;
            span{
                color: #cc171d;
            }
        }
    }
    .title{
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        ul{
            /*display: flex;*/
            /*align-items: center;*/
            /*justify-content: right;*/
            list-style-type: none;

            li{

                padding: 5px;
                img{
                    margin-top: 5px;
                    width: 9px!important;
                    height: auto!important;
                }
                display: inline-block;
                span{
                    color: #cc171d;
                }
            }
        }

    }
    .form-title{
        font-size: 22px!important;
    }
    .form-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #detail-txt>a{
        color: #162336;
        text-decoration: underline;
    }
    button{
        max-width: 369px;
        width: 90%;
        height: 54px;
        margin: auto;
        background-color: #162336;
        color: white;
        border: solid 1px #979797;
        border-radius: 10px;
        transition: 0.1s all;
    }
    button:hover{
             background-color: #fe7063;
             color: white;
         }
    #email-input{
        text-align: left;
        padding-right: 15px;
    }
    .text-field {
        position: relative;
        margin: 10px 2.5px 20px 2.5px;
    }
    input:focus {
        border: thin solid #32cd32;
        border-bottom: solid medium #32cd32;
        background-color:#fff;
    }
    label {
        position: absolute;
        pointer-events: none;
        right: 10px;
        top: 5px;
        transition: 0.2s;
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        opacity: 1;
    }
    input:focus ~ label, input:valid ~ label {
        top: -12px;
        right: 15px;
        font-size: small;
        color:  #fe7063;
        padding:0 5px 0 5px;
        background-color: white;

    }
    input{
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        width: 300px;
        height: 40px;
        border-radius: 5px!important;
        opacity: 0.5;
        border: solid 0.5px #162336;
    }
    input:focus{
        border: solid 2px #fe7063!important;
    }
    *:focus {
        border: solid 0.5px #162336!important;
    }
    #register-form-content>form{
        margin-top: 50px;
    }
    textarea:focus{
        border: solid 2px #fe7063!important;
    }
</style>